import { c as _c } from "react/compiler-runtime";
import { LANGUAGES, SUPPORTED_LANGUAGES } from '@onefootprint/core';
import { IcoCheck16 } from '@onefootprint/icons';
import type { Language } from '@onefootprint/request-types';
import { BottomSheet } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { LEGACY_IDV_CONTAINER_ID as LAYOUT_CONTAINER_ID } from '@/idv2/components/constants';
import useSwitchLanguage from '../../use-switch-language';
type LanguageSheetProps = {
  open: boolean;
  onClose: () => void;
};
const LanguageSheet = t0 => {
  const $ = _c(16);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "shell.global.components.footer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t,
    i18n
  } = useTranslation("idv2", t1);
  const switchLanguage = useSwitchLanguage();
  let t2;
  if ($[1] !== onClose || $[2] !== switchLanguage) {
    t2 = language => {
      switchLanguage(language);
      onClose();
    };
    $[1] = onClose;
    $[2] = switchLanguage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSelect = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleSelect || $[7] !== i18n) {
    t4 = SUPPORTED_LANGUAGES.map(language_0 => {
      const isCurrent = language_0 === i18n.language;
      return <li key={language_0}><button type="button" lang={language_0} aria-current={isCurrent} onClick={() => {
          handleSelect(language_0);
        }} className="flex w-full items-center justify-between rounded-default px-3 py-3 text-body-2 text-primary hover:bg-hover">{LANGUAGES[language_0].nativeName}{isCurrent && <IcoCheck16 />}</button></li>;
    });
    $[6] = handleSelect;
    $[7] = i18n;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <ul className="flex flex-col gap-1 mb-5">{t4}</ul>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onClose || $[12] !== open || $[13] !== t3 || $[14] !== t5) {
    t6 = <BottomSheet open={open} onClose={onClose} title={t3} containerId={LAYOUT_CONTAINER_ID} portalId={LAYOUT_CONTAINER_ID}>{t5}</BottomSheet>;
    $[11] = onClose;
    $[12] = open;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default LanguageSheet;
function _temp($) {
  return $["change-language"];
}